define(
  'id',[
    'underscore',
    'utils/wrapper',
    'utils/dom_ready',
    'sdk',
    'runtime',
    'auth',
    'event',
    'utils/hide_plugin',
    'rpc',
    'dialogs_manager',
    'tracking',
    'analytics',
    'options',
    'logger',
    'app_image',
    'playtomic',
    'protection',
    'secret_menu',
    'multiplayer',
  ], function(
    _,
    __w,
    domReady,
    SDK,
    Runtime,
    Auth,
    _Event,
    HidePlugin,
    RPC,
    DialogsManager,
    Tracking,
    Analytics,
    Options,
    Logger,
    AppImage,
    Playtomic,
    Protection,
    SecretMenu,
    Multiplayer
  ) {
  return function(window){
    window.ID = {
      Event: _Event,
      track: function(params){
        var i = setInterval(function(){
          if (Runtime.initialized()) {
            Tracking.track(Runtime.getAppId(), params);
            clearInterval(i);
          }
        }, 500);
      },
      underscore: _,
      api: function(path, method, params, cb) {SDK.api.api(path, method, params, cb);},
      login: function(cb, options){
        Auth.login(options, __w(cb), __w(cb));
        Logger.addCall();
      },
      register: function(cb, options){
        Auth.register(options, __w(cb), __w(cb));
        Logger.addCall();
      },
      getAuthResponse: function(cb){
        return __w(cb).call({}, Runtime.getAuthResponse());
      },
      getLoginStatus: function(cb, force, options){
        var data = Runtime.getLoginStatus() || {};
        if (force) {
          Logger.addCall();
          return Auth.fetchLoginStatus(cb, cb, options);
        }
        if (data.status && data.authResponse) {
          return __w(cb).call({}, data);
        }
        Auth.fetchLoginStatus(cb, cb, options);
      },
      ui: function(options, successCb, errorCb) {
        DialogsManager.open(options, successCb, errorCb);
        Logger.addCall();
      },
      leaderboard: function(){
        DialogsManager.open({method: "leaderboard", redirect_uri: Runtime.getRedirectUri()});
        Logger.addCall();
      },
      certification: function(){
        DialogsManager.open({ method: "certification", redirect_uri: Runtime.getRedirectUri() });
        Logger.addCall();
      },
      points_leaderboard: function(){
        DialogsManager.open({method: "points_leaderboard", redirect_uri: Runtime.getRedirectUri()});
      },
      submit_image: function(picture, cb){
        AppImage.submit(picture, cb);
        Logger.addCall();
      },
      GameAPI: Playtomic,
      Protection: Protection,
      Multiplayer: Multiplayer,
      Analytics: Analytics.developer,
      hidePluginElement: HidePlugin.hidePluginElement,
      showPluginElement: HidePlugin.showPluginElement,
      init: function init(opts){
        // resets for testing
        if (opts.forceInit) {
          Runtime.reset();
          Options.reset();
          Analytics.reset();
        } else {
          if (Runtime.initialized()) return;
        }
        Runtime.init(opts);
        if (Runtime.initialized()) {
          try {
            // Initialize RPC
            RPC.xdHandler();
            Options.update();
            Analytics.init(this);
            SecretMenu.init();
          }
          catch(e){
            Logger.log('Error in id '+e);
          }
        }
        if (opts && opts.status) {
          ID.getLoginStatus();
        }
      }
    };

    domReady(function(){
      if (_.isFunction(window.idAsyncInit)) {
        window.idAsyncInit();
      }
    });
  };
});

